import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IDefaultBackgroundProps {
  section?: string;
  imageUrl?: string;
}

export const DefaultBackground: React.VFC<IDefaultBackgroundProps> = ({ section, imageUrl }) => {
  return (
    <div className={styles['container']}>
      <div
        className={classNames(styles['image'], section && styles[section])}
        style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}}
      />
    </div>
  );
};
